import React from 'react'
import PropTypes from 'prop-types'
import Portal from 'components/Shared/Portal'
import Modal from 'components/Shared/Modal'
import { useGoogleTestCampaignContext } from './testCampaignContext'
import GoogleAssetSelectionStep from './AssetSelectionStep'
import GoogleProgressView from './ProgressView'
import GoogleSuccessView from './SuccessView'
import GoogleErrorView from './ErrorView'

export default function GoogleTestCampaignModal({ assets }) {
  const { modalOpen, modalView, currentCampaign, closeModal, retry, clearSelection, error } =
    useGoogleTestCampaignContext()

  const handleRunAnother = () => {
    clearSelection()
    retry()
  }

  const renderContent = () => {
    switch (modalView) {
      case 'selection':
        return <GoogleAssetSelectionStep assets={assets} onCancel={closeModal} error={error} />

      case 'progress':
        return currentCampaign ? (
          <GoogleProgressView campaign={currentCampaign} onClose={closeModal} />
        ) : null

      case 'success':
        return currentCampaign ? (
          <GoogleSuccessView
            campaign={currentCampaign}
            onClose={closeModal}
            onRunAnother={handleRunAnother}
          />
        ) : null

      case 'error':
        return currentCampaign ? (
          <GoogleErrorView campaign={currentCampaign} onClose={closeModal} onRetry={retry} />
        ) : (
          <GoogleAssetSelectionStep assets={assets} onCancel={closeModal} error={error} />
        )

      default:
        return null
    }
  }

  return modalOpen ? (
    <Portal wrapperId="app-portal">
      <Modal
        isOpen={modalOpen}
        onClickOutside={closeModal}
        closeCallback={closeModal}
        offWhiteBg
        size="md"
        fullWidth={false}
        mainContent={<div className="test-campaign-modal">{renderContent()}</div>}
      />
    </Portal>
  ) : null
}

GoogleTestCampaignModal.propTypes = {
  assets: PropTypes.array.isRequired,
}
